
import $profile from 'stores/profile'
import MemoryEditor from './memory-editor.vue'
import MemoryItem from './memory-item.vue'
import {markRaw} from 'vue'

const MEMORY_LIMIT = 30
const SYMBOL_LIMIT = 300

export default {
  components: {
    MemoryEditor,
    MemoryItem
  },
  data() {
    return {
      MEMORY_LIMIT: markRaw(MEMORY_LIMIT),
      SYMBOL_LIMIT: markRaw(SYMBOL_LIMIT)
    }
  },
  computed: {
    memories: {
      get() {
        return $profile.memory
      },
      set(val) {
        $profile.memory = val
      }
    },
    at_limit() {
      return this.memories.length >= MEMORY_LIMIT
    },
    memory_items() {
      return this.memories.map((text, index) => ({
        id: `memory-${index}`,
        text,
        index
      }))
    },
    saving() {
      return $profile.saving
    },
    saved_at() {
      return $profile.saved_at
    },
  },
  methods: {
    async saveMemory() {
      await $profile.save(['memory'])
    },
    onEdit(index) {
      this.$refs.editor.edit(index, this.memories[index])
    },
    async onAdd(text) {
      this.memories.push(text)
      await this.saveMemory()
      this.$refs.editor.onDiscard()
    },
    async onSave(index, text) {
      this.memories.splice(index, 1, text)
      await this.saveMemory()
      this.$refs.editor.onDiscard()
    },
    async onRemove(index) {
      this.memories.splice(index, 1)
      await this.saveMemory()
      this.$refs.editor.onDiscard()
    },
  }
}
